<template>
  <div>
        <el-collapse v-if="task_list.length > 0" v-model="activeNames">
            <template v-for="(item, index) in task_list">
                <el-collapse-item :title="item.task_name" :name="index" :key="item.id" style="border:1px solid #eeeeee;border-radius:5px;margin-top:17px;">
                    <template slot="title">
                        <div class="collapse_title">
                            <span style="color:#ffaa2c;font-size:12px;border:1px solid #ffd18c;border-radius:5px;height:24px;line-height:24px;background:#fff9ef;padding:0 5px;" class="item">{{ item.valid_status }}</span>
                            <span style="color:#333333;margin-left:10px;font-size:14px;" class="item">{{ item.task_name }}</span>
                            <span v-if="item.mana_survey==1" style="margin-left:5px;font-size:12px;color:#67C23A;font-weight:bold;border:1px solid #67C23A;border-radius:3px;height:15px;line-height:15px;" class="item">调</span>
                            <span style="color:#aaaaaa;font-size:14px;margin-right:25px;" class="item">({{ item.effective_date }} ~ {{ item.expiration_date }})</span>
                        </div>
                    </template>
                    <div style="padding:0 20px;">
                        <el-table
                        :data="item.chengshu_todolist"
                        style="width: 100%">
                            <!-- <el-table-column prop="id" label="序号" min-width="5%"></el-table-column> -->
                            <el-table-column type="index"></el-table-column>
                            <el-table-column prop="assessee" label="被评估人" min-width="18%"></el-table-column>
                            <el-table-column prop="company" label="公司" min-width="14%"></el-table-column>
                            <el-table-column prop="department" label="部门" min-width="14%"></el-table-column>
                            <el-table-column prop="type" label="评估类型" min-width="13%">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.type }}</span>
                                    <span style="margin-left:3px;">
                                        <el-tooltip v-if="scope.row.type=='自评'" content="表示被评估人本人，对照管理基本功要求，进行自我评估" effect="light" placement="right">
                                            <i class="el-icon-info" style="color:#AAAAAA" />
                                        </el-tooltip>
                                        <el-tooltip v-if="scope.row.type=='上级评估'" content="表示作为被评估人的上级角色，对当前下属（即被评估人）的管理基本功水平评估" effect="light" placement="right">
                                            <i class="el-icon-info" style="color:#AAAAAA" />
                                        </el-tooltip>
                                        <el-tooltip v-if="scope.row.type=='peer评估'" content="表示作为被评估人的peer角色，对同级peer（即被评估人）的管理基本功水平进行评估" effect="light" placement="right">
                                            <i class="el-icon-info" style="color:#AAAAAA" />
                                        </el-tooltip>
                                        <el-tooltip v-if="scope.row.type=='下级评估'" content="表示作为被评估人的下属角色，对当前上级（即被评估人）进行管理基本功水平评估" effect="light" placement="right">
                                            <i class="el-icon-info" style="color:#AAAAAA" />
                                        </el-tooltip>
                                        <el-tooltip v-if="scope.row.type=='管理痛点调研'" content="表示作为被评估人本人，对照管理痛点列表，投票选择自己在实际工作中遇到的管理痛点" effect="light" placement="right">
                                            <i class="el-icon-info" style="color:#AAAAAA" />
                                        </el-tooltip>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="status" label="评估状态" min-width="12%">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.status=='未开始'" class="not_start">未开始</div>
                                    <div v-if="scope.row.status=='已完成'" class="started">已完成</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="score" label="评估得分" min-width="12%"></el-table-column>
                            <el-table-column prop="operations" label="操作" min-width="16%">
                                <template slot-scope="scope">
                                    <el-button
                                    v-if="scope.row.status=='未开始' && scope.row.type!='管理痛点调研'"
                                    size="mini"
                                    type="primary"
                                    @click="start_evaluating(scope.row, item.id, item.task_name)">开始评估</el-button>
                                    <el-button
                                    v-if="scope.row.status=='未开始' && scope.row.type=='管理痛点调研'"
                                    size="mini"
                                    type="primary" 
                                    @click="start_evaluating_survey(scope.row, item.id, item.task_name)">开始评估</el-button>
                                    <el-button
                                    v-if="scope.row.status=='已完成' && scope.row.type!='管理痛点调研'"
                                    size="mini"
                                    type="primary" 
                                    @click="view_details(scope.row, item.id, item.task_name)">查看详情</el-button>
                                    <!-- 到时候这边修改为“查看/更新”，原来是“查看详情” -->
                                    <el-button
                                    v-if="scope.row.status=='已完成' && scope.row.type=='管理痛点调研'"
                                    size="mini"
                                    type="primary" 
                                    @click="view_details_survey(scope.row, item.id, item.task_name)">查看详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-collapse-item>
            </template>
        </el-collapse>
        <!-- 原来的dialog宽度是1350px -->
        <el-dialog 
        title="" 
        :visible.sync="dialogFormVisible" 
        width="1000px" 
        :destroy-on-close="true" 
        :close-on-click-modal="false">
            <!-- 这里直接引用scope.row中的属性无效，所以用form引用该row，通过form去引用对应的元素 -->
            <template slot="title">
                <span style="font-weight:bold;font-size:18px;">管理基本功评估</span>
                <span style="font-weight:bold;font-size:16px;"> (被评估人：</span>
                <span style="font-weight:bold;font-size:16px;color:#409EFF;">{{ form.assessee }}</span>
                <span style="font-weight:bold;font-size:16px;"> /评估类型：</span>
                <span style="font-weight:bold;font-size:16px;color:#409EFF;">{{ form.type }})</span>
            </template>
            <div style="padding-left:20px;padding-right:20px;text-align:left;font-size:16px;color:#67C23A;">
                <p style="margin: 0px;">
                    <span style="padding-left:30px;">欢迎您进入管理基本功测评系统。</span><span style="color:#F56C6C;font-weight:bold;">本测评结果会严格匿名保密，且不涉及任何晋升与奖惩，结果并无好坏对错之分，是一次管理成熟度照镜子的过程。</span><span>您只需要根据被评估人日常工作管理行为进行评分即可。自评环节帮助您反思和觉察自己的领导力行为，他评环节基于周边360度角色，帮助您作评估对比参考。请避免出现全部选项打分一样的情况。</span>
                </p>
                <p style="margin-top: 0px;">
                    <span style="font-weight:bold;padding-left:30px;">只需要15分钟，即可完成您的评测之旅。</span>
                </p>
            </div>
            <!-- 这里通过sendData监听子组件的$emit方法，并通过父组件的getData方法获取子组件传递的数据 -->
            <quesmana ref="ques_mana" @sendData="getQuesResults" :question_info="question_info" :proof_info="proof_info" :error_flag="error_flag"></quesmana>
            <!-- 按钮的显示，增加一个question_info.length的条件，只有当问卷加载成功后才显示，防止一闪的时候显示按钮 -->
            <div style="text-align:center;" v-if="form.status=='未开始' && question_info.length > 0">
            <!-- <div style="text-align:center;"> -->
                <el-button @click="dialogCancel">取 消</el-button>
                <el-button type="primary" @click="dialogSubmit" v-if="form.status=='未开始'">提 交</el-button>
                <!-- <el-button type="primary" @click="dialogSubmit" v-if="form.status=='已完成'">更 新</el-button> -->
            </div>
        </el-dialog>
        <el-dialog 
        title="" 
        :visible.sync="dialogFormVisible_survey" 
        width="1350px" 
        :destroy-on-close="true" 
        :close-on-click-modal="false">
            <!-- 这里直接引用scope.row中的属性无效，所以用form引用该row，通过form去引用对应的元素 -->
            <template slot="title">
                <span style="font-weight:bold;font-size:18px;">管理痛点调研</span>
                <span style="font-weight:bold;font-size:16px;"> (姓名：</span>
                <span style="font-weight:bold;font-size:16px;color:#409EFF;">{{ form.assessee }})</span>
            </template>
            <!-- 这里通过sendData监听子组件的$emit方法，并通过父组件的getData方法获取子组件传递的数据 -->
            <survey-mana ref="survey_mana" @sendData="getSurveyResults" :survey_info="survey_info" :error_flag_survey="error_flag_survey"></survey-mana>
            <!-- 按钮的显示，增加一个question_info.length的条件，只有当问卷加载成功后才显示，防止一闪的时候显示按钮 -->
            <div style="text-align:center;" v-if="form.status=='未开始' && survey_info.length > 0">
            <!-- <div style="text-align:center;"> -->
                <el-button @click="dialogCancel_survey">取 消</el-button>
                <el-button type="primary" @click="dialogSubmit_survey" v-if="form.status=='未开始'">提 交</el-button>
                <!-- <el-button type="primary" @click="dialogSubmit_survey" v-if="form.status=='已完成'">更 新</el-button> -->
            </div>
        </el-dialog>
        <div class="no_task" v-if="task_list.length <= 0">
            <span>暂无待评估的任务。</span>
        </div>
        <!-- <div style="margin-top:10px;" v-if="chengshu_todolist.length > 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageinfo.count"
                :page-sizes="pageinfo.page_sizes"
                :page-size="pageinfo.page_size"
                layout="total, sizes, prev, pager, next"
                :total="pageinfo.count">
            </el-pagination>
        </div> -->
  </div>
</template>

<script>
import quesmana from "../QuestionManagement/ChengShu_quesmana.vue";
import surveyMana from "../QuestionManagement/ChengShu_survey.vue";
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    created() {
        this.getToDoList();
    },
    // beforeUpdate() {
    //     this.display_flag = true;
    // },
    components: {
        quesmana,
        surveyMana,
    },
    data() {
        return {
            task_list: [],
            // display_flag: false,
            // pageinfo: {
            //     count: 0,
            //     current: 1,
            //     page_size: 10,
            //     page_sizes: [1, 10, 20, 50, 100],
            // },
            // chengshu_todolist: [
            //     // {
            //     //     id: 1,
            //     //     assessee: '张三',
            //     //     company: '软通',
            //     //     department: '部门A',
            //     //     type: '自评',
            //     //     status: '未开始',
            //     //     score: '-',
            //     // },{
            //     //     id: 2,
            //     //     assessee: '李四',
            //     //     company: '软通',
            //     //     department: '部门A',
            //     //     type: 'peer评估',
            //     //     status: '未开始',
            //     //     score: '-',
            //     // }
            // ],
            form: {},
            dialogFormVisible: false,
            dialogFormVisible_survey: false,
            submit_question_info: [],
            submit_survey_info: [],
            submit_proof_info: [],
            qid_list: [],
            result_list: [],
            request_info: {},
            unfinish_num: 0,
            question_info: [],
            survey_info: [],
            proof_info: [],
            check_flag: true,
            error_flag: false,  //标识检查是否有错误，用于标红未答的主观题
            check_flag_survey: true,
            error_flag_survey: false,  //标识检查是否有错误，用于标红未答的主观题
            activeNames: [],
        };
    },
    methods: {
        start_evaluating(row, task_id, task_name) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            // this.getManaQues(task_id);
            // this.form = row;
            // 增加task_id的获取，提交问卷需要补充task_id
            // this.form['task_id'] = task_id;
            // this.dialogFormVisible = true;
            this.$router.push({
                name: 'MyAssTask',
                query: {
                    taskid: task_id,
                    task_name: task_name,
                    type: row.type,
                    ass: row.assessee,
                    rid: row.id,
                    opt: 'eval',    // eval：参与评估  view：查看评估
                }
            })
        },
        start_evaluating_survey(row, task_id, task_name) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            // this.getManaSurvey(task_id);
            // this.form = row;
            // 增加task_id的获取，提交问卷需要补充task_id
            // this.form['task_id'] = task_id;
            // this.dialogFormVisible_survey = true;
            this.$router.push({
                name: 'MyAssTask',
                query: {
                    taskid: task_id,
                    task_name: task_name,
                    type: row.type,
                    ass: row.assessee,
                    rid: row.id,
                    opt: 'eval',
                }
            })
        },
        view_details(row, task_id, task_name) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            // this.getManaQues(task_id, row);
            // 如果是查询详情，则需要使用被评估人id和评估类型，从后台获取评估结果进行展示
            // this.getResultByUser(row.id, row.type, task_id);
            // this.form = row;
            // 查询页增加更新功能后，也需要补充task_id
            // this.form['task_id'] = task_id;
            // this.dialogFormVisible = true;
            this.$router.push({
                name: 'MyAssTask',
                query: {
                    taskid: task_id,
                    task_name: task_name,
                    type: row.type,
                    ass: row.assessee,
                    rid: row.id,
                    opt: 'view',
                }
            })
        },
        view_details_survey(row, task_id, task_name) {
            // 改用从父组件直接从后台获取问卷信息，并传给子组件
            // this.getManaSurvey(task_id, row);
            // 如果是查询详情，则需要使用被评估人id和评估类型，从后台获取评估结果进行展示
            // this.getResultByUser_survey(row.id, task_id);   
            // this.form = row;
            // 查询页增加更新功能后，也需要补充task_id
            // this.form['task_id'] = task_id;
            // this.dialogFormVisible_survey = true;
            this.$router.push({
                name: 'MyAssTask',
                query: {
                    taskid: task_id,
                    task_name: task_name,
                    type: row.type,
                    ass: row.assessee,
                    rid: row.id,
                    opt: 'view',
                }
            })
        },
        dialogCancel() {
            this.dialogFormVisible = false;
        },
        dialogCancel_survey() {
            this.dialogFormVisible_survey = false;
        },
        dialogSubmit() {
            this.$confirm('提交后将无法修改, 请确认是否提交?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 触发子组件的$emit方法向父组件传递数据
                this.$refs.ques_mana.submitManaQues();
                // 答题不完整，check_flag会被设置为false，则终止提交
                if(this.check_flag == false){
                    return;
                }
                // this.dialogFormVisible = false;
                // 提交问卷后，需要刷新当前评估人的评估状态数据，以及更新待处理评估数
                // this.getToDoList();
                // this.updateToDoNum();
            }).catch( err => {
                console.log(err);
            })
        },
        dialogSubmit_survey() {
            this.$confirm('提交后将无法修改, 请确认是否提交?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 触发子组件的$emit方法向父组件传递数据
                this.$refs.survey_mana.submitManaSurvey();
                // 答题不完整，check_flag会被设置为false，则终止提交
                if(this.check_flag == false){
                    return;
                }
                // this.dialogFormVisible_survey = false;
                // 提交问卷后，需要刷新当前评估人的评估状态数据，以及更新待处理评估数
                // this.getToDoList();
                // this.updateToDoNum();
            }).catch( err => {
                console.log(err);
            })
        },
        checkManaQues() {
            for(var cg in this.submit_question_info){
                for(var scg in this.submit_question_info[cg]['sub_category']){
                    for(var sj in this.submit_question_info[cg]['sub_category'][scg]['subject']){
                        if(this.submit_question_info[cg]['sub_category'][scg]['subject'][sj]['selected_option'] == ''){
                            this.$message({
                                message: '有未完成的答题，请检查！',
                                type: 'error',
                                duration: 6000,
                                // showClose: true,
                            })
                            this.check_flag = false;
                            this.error_flag = true;
                            console.log("this.error_flag: " + this.error_flag);
                            return;
                        }
                    }
                }
            }
            // 如果检查没问题，重新赋值check_flag为true
            this.check_flag = true;
            this.error_flag = false;
            console.log("this.error_flag: " + this.error_flag);
        },
        checkManaSurvey() {
            for(var i in this.submit_survey_info){
                if(this.submit_survey_info[i]['choice_type']=='多选' && this.submit_survey_info[i]['selected_option']=='其他'){
                    if(!this.submit_survey_info[i]['proof']){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag_survey = false;
                        this.error_flag_survey = true;
                        console.log("this.error_flag_survey: " + this.error_flag_survey);
                        return;
                    }
                }else{
                    if(this.submit_survey_info[i]['selected_option'] == ''){
                        this.$message({
                            message: '有未完成的答题，请检查！',
                            type: 'error',
                            duration: 6000,
                            // showClose: true,
                        })
                        this.check_flag_survey = false;
                        this.error_flag_survey = true;
                        console.log("this.error_flag_survey: " + this.error_flag_survey);
                        return;
                    }
                }
            }
            // 如果检查没问题，重新赋值check_flag为true
            this.check_flag_survey = true;
            this.error_flag_survey = false;
        },
        // 父组件获取子组件传递的问卷结果信息
        getQuesResults(data) {
            // 处理问卷结果信息，并提交后台处理
            this.submit_question_info = data[0];
            // 提交问卷前，需要先检查是否有未完成的题目（主要是选择题）
            this.checkManaQues();
            if(this.check_flag == false){
                return;
            }
            // 每次提交记录前，需要重置qid_list和result_list，防止连续提交时数据累加导致结果错误
            this.qid_list = [];
            this.result_list = [];
            // console.log('getData: subject_desc_sub= ' + this.submit_question_info[0]['sub_category'][0]['subject'][0]['subject_desc_sub']);          
            for(var cg in this.submit_question_info){
                for(var scg in this.submit_question_info[cg]['sub_category']){
                    for(var sj in this.submit_question_info[cg]['sub_category'][scg]['subject']){
                        this.qid_list.push(this.submit_question_info[cg]['sub_category'][scg]['subject'][sj]['qid']);
                        this.result_list.push(this.submit_question_info[cg]['sub_category'][scg]['subject'][sj]['selected_option']);
                    }
                }
            }
            this.submit_proof_info = data[1];
            for(var pf in this.submit_proof_info){
                this.qid_list.push(this.submit_proof_info[pf]['qid']);
                this.result_list.push(this.submit_proof_info[pf]['proof']);
            }
            this.request_info['assessee_id'] = this.form['id'];
            // this.request_info['company'] = this.form['company'];
            this.request_info['eval_type'] = this.form['type'];
            this.request_info['task_id'] = this.form['task_id'];
            this.request_info['qid_list'] = this.qid_list;
            this.request_info['result_list'] = this.result_list;
            postdata.postList("submitManaQues", JSON.stringify(this.request_info))
              .then(resp => {
                if(resp.data.code == 200){
                  this.$message({
                    message: resp.data.message,
                    type: "success",
                    })
                // 将关闭窗口改放到这里，超出连续值范围时，不会退出窗口重新答题，可以继续修改后重新提交
                  this.dialogFormVisible = false;
                  this.getToDoList();
                }else{
                  this.$message({
                    message: resp.data.message,
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                    })
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        getSurveyResults(data) {
            // 每次提交记录前，需要重置submit_survey_info，防止连续提交时数据累加导致结果错误
            this.submit_survey_info = [];
            for(var survey in data) {
                var survey_reslut = {};
                survey_reslut['assessee_id'] = this.form['id'];
                survey_reslut['qid'] = data[survey].qid;
                survey_reslut['choice_type'] = data[survey].choice_type;
                survey_reslut['display_num'] = data[survey].display_num;
                survey_reslut['selected_option'] = data[survey].selected_option;
                survey_reslut['proof'] = data[survey].proof;
                survey_reslut['task_id'] = this.form['task_id'];
                this.submit_survey_info.push(survey_reslut);
            }
            this.checkManaSurvey();
            if(this.check_flag_survey == false){
                return;
            }
            
            postdata.postList("submitManaSurvey", JSON.stringify(this.submit_survey_info))
              .then(resp => {
                if(resp.data.code == 200){
                  this.$message({
                    message: resp.data.message,
                    type: "success",
                    })
                  this.dialogFormVisible_survey = false;
                  this.getToDoList();
                }else{
                  this.$message({
                    message: resp.data.message,
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                    })
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        updateToDoNum() {
            // console.log('updateToDoNum-unfinish_num: ' + this.unfinish_num);
            this.$emit('sendToDoNum', this.unfinish_num);
        },
        getToDoList() {
            getdata.getList("getToDoList")
                .then(resp => {
                    if(resp.data.code == 200){
                        this.task_list = resp.data.data;
                        this.unfinish_num = resp.data.unfinish_num;
                        // 获取到未完成评测数后，同步给父组件
                        this.updateToDoNum();
                        this.activeNames = this.task_list.map((_, index) => index);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getManaQues(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getManaQues", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.question_info = resp.data.choice;
                    this.proof_info = resp.data.proof;
                    // console.log("question_info: " + this.question_info);
                    // console.log("proof_info" + this.proof_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    if(r != 'none_rows'){
                        this.getResultByUser(r.id, r.type, task_id);
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getManaSurvey(task_id, row) {
            let r = row || 'none_rows';
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getManaSurvey", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.survey_info = resp.data.survey_info;
                    // console.log("survey_info: " + this.survey_info);
                    // 获取结果的处理需要放在成功获取到问卷之后，否则会触发获取结果早于获取问卷的情况，导致问卷中无结果信息
                    if(r != 'none_rows'){
                        this.getResultByUser_survey(r.id, task_id);  
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getResultByUser(assessee_id, eval_type, task_id) {
            let params;
            params = {
                assessee_id: assessee_id,
                eval_type: eval_type,
                task_id: task_id,
            } 
            
            getdata.getListP("getManaResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    var result = resp.data.data;
                    // console.log('result: ' + result + ' ' + result[0]);
                    var i = 0; 
                    // 首先是选择题
                    for(var cg in this.question_info){
                        for(var scg in this.question_info[cg]['sub_category']){
                            for(var sj in this.question_info[cg]['sub_category'][scg]['subject']){
                                this.question_info[cg]['sub_category'][scg]['subject'][sj]['selected_option'] = result[i];
                                i = i + 1;
                            }
                        }
                    }
                    // console.log("question_info2: " + this.question_info);
                    // 然后是举证题
                    for(var pf in this.proof_info){
                        this.proof_info[pf]['proof'] = result[i];
                        i = i + 1;
                    }
                    // console.log("proof_info2: " + this.proof_info);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getResultByUser_survey(assessee_id, task_id) {
            let params;
            params = {
                assessee_id: assessee_id,
                task_id: task_id,
            } 
            
            getdata.getListP("getManaSurveyResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    let results = resp.data.data;
                    for(var survey in results) {
                        this.survey_info[survey]['assessee_id'] = results[survey]['assessee_id'];
                        this.survey_info[survey]['qid'] = results[survey]['qid'];
                        this.survey_info[survey]['choice_type'] = results[survey]['choice_type'];
                        this.survey_info[survey]['display_num'] = results[survey]['display_num'];
                        this.survey_info[survey]['selected_option'] = results[survey]['selected_option'];
                        this.survey_info[survey]['proof'] = results[survey]['proof'];
                        this.survey_info[survey]['task_id'] = results[survey]['task_id'];
                    }
                    // console.log("survey_info2: " + this.survey_info);
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
    }
};
</script>

<style scoped>
.not_start {
    font-size: 12px;
    background: #fff0f2;
    display: inline-block;
    white-space: nowrap;
    padding: 4.5px 8.5px;
    border-radius: 5px;
    line-height: 1;
    color: #e54c5e;
    border: 1px solid #e54c5e;
}
.started {
    font-size: 12px;
    background: #FAFFEF;
    display: inline-block;
    white-space: nowrap;
    padding: 4.5px 8.5px;
    border-radius: 5px;
    line-height: 1;
    color: #88C200;
    border: 1px solid #88C200;
}
::v-deep .el-table__header {
    font-size: 14px;
    font-weight: normal;
}
/* .el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
} */
/* .el-table /deep/ th {
    font-weight: normal;
} */
/* ::v-deep .el-dialog {
    height: 600px;
} */
/* 设置dialog的滚动条 */
::v-deep .el-dialog__body {
    max-height: 600px !important;
    min-height: 100px;
    overflow-y: auto;
}
::v-deep .el-collapse-item__header {
    font-size: 18px;
    /* font-weight: bold; */
    color: #409eff;
    padding-left: 20px;
    background-color: #f8f8f8;
    border-bottom: none;
}
::v-deep .el-collapse-item__header.is-active {
    border-bottom: 1px solid #eeeeee;
}
.no_task {
  width: 100%;
  margin: 0 auto;
  color: #909399;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
}
::v-deep .el-dialog__header {
  text-align: left;
}
::v-deep .el-collapse {
  border: none;
  margin-bottom: 20px;
}
::v-deep .el-collapse-item__wrap {
  border-bottom: none;
}
::v-ddep .el-collapse-item__content {
  padding-bottom: 15px;
}
::v-deep .el-button--mini {
  padding: 4.5px 8.5px;
  border-radius: 5px;
}
::v-deep .el-button--primary {
    background-color: #42b6ff;
    border-color: #42b6ff;
}
.collapse_title {
    display: flex;
    width: 100%;
    align-items: center;
}
.collapse_title .item:last-child {
    margin-left: auto;
}
</style>